import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';

export const fetchCustomSectionListService = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CUSTOM_SECTION_TEMPLATE.COMMON_PATH}`, { params: { ...data } });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const addSectionTemplateActionService = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.CUSTOM_SECTION_TEMPLATE.ADD_CUSTOMSECTION}`, { ...data });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const deleteSectionService = async (payload, deleteId, rangeplanId, sectionName) => {
  console.log(payload, deleteId, sectionName);
  try {
    return await apiClient.delete(`${apiEndpoint}${API.CUSTOM_SECTION_TEMPLATE.COMMON_PATH}/${rangeplanId}/${deleteId}`, {
      params: { ...payload, sectionName },
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const fetchCustomColumnListService = async (sectionId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CUSTOM_SECTION_TEMPLATE.COMMON_PATH}/${sectionId}`);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const saveColumnChangesService = async (data, columns) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.CUSTOM_SECTION_TEMPLATE.COLUMN_NAME_CHANGE}`, { columns }, { params: { ...data } });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const deleteSectionColumnService = async (columnId, sectionId, rangeplanId) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.CUSTOM_SECTION_TEMPLATE.COLUMN}/${rangeplanId}/${sectionId}/${columnId}`);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const bulkDeleteSectionColumnsService = async (deleteData, rangeplanId) => {
  try {
    // Handle both formats - new array format and old single section format
    let requestData;
    if (Array.isArray(deleteData)) {
      // New format: [{sectionId: "123", columns: ["456", "567"]}, ...]
      requestData = {
        deleteData,
      };
    } else {
      // Old format: {columnIds: [...], sectionId: "..."}
      requestData = {
        ...deleteData,
      };
    }

    return await apiClient.post(`${apiEndpoint}${API.CUSTOM_SECTION_TEMPLATE.BULK_DELETE_COLUMNS}/${rangeplanId}`, requestData);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const addColumnInSectionService = async (data, sectionId, rangeplanId) => {
  try {
    return await apiClient.put(
      `${apiEndpoint}${API.CUSTOM_SECTION_TEMPLATE.COMMON_PATH}/${rangeplanId}/${sectionId}`,
      { columns: data.columns },
      { params: { mode: data.mode } },
    );
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const updateColumnInSectionService = async (data, sectionId, rangeplanId, columnId) => {
  try {
    return await apiClient.put(
      `${apiEndpoint}${API.CUSTOM_SECTION_TEMPLATE.COLUMN}/${rangeplanId}/${sectionId}/${columnId}`,
      { column: data.columns },
      { params: { mode: data.mode } },
    );
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const applyDefaultOptionsForCustomSectionService = async (sectionId, rangeplanId) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.CUSTOM_SECTION_TEMPLATE.APPLY_DEFAULT_OPTIONS}`, {
      sectionId,
      rangeplanId,
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const fetchAllSectionsService = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CUSTOM_SECTION_TEMPLATE.FETCH_ALL_SECTIONS_COLUMNS}`);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const updateSequenceForCustomSectionService = async (params, data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.CUSTOM_SECTION_TEMPLATE.UPDATE_CUSTOMSECTION_SEQUENCE}/${params}`, {
      sequence: [...data],
    });
  } catch (error) {
    console.log(error);

    throw error;
  }
};

export const setDefaultSectionService = async (params) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.CUSTOM_SECTION_TEMPLATE.SET_DEFAULT_CUSTOMSECTION}/${params}`);
  } catch (err) {
    console.log(err);
    throw err;
  }
};

// ✅ Service method following API integration pattern
export const addCustomSectionService = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.CUSTOM_SECTION_TEMPLATE.ADD_CUSTOMSECTION}`, data);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// ✅ Update custom section service method following API integration pattern
export const updateCustomSectionService = async (sectionId, data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.CUSTOM_SECTION_TEMPLATE.UPDATE_CUSTOMSECTION}/${sectionId}`, data);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const fetchAllSelectedRPSections = async (rangeplanId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.CUSTOM_SECTION_TEMPLATE.FETCH_ALL_SELECTED_RP_SECTIONS}/${rangeplanId}`);
  } catch (error) {
    console.log(error);
    throw error;
  }
};
